import React from 'react';
import { PlayerSummaryCard } from '../components/PlayerSummaryCard';
export function Display() {
  return <div className="p-8 max-w-6xl mx-auto" data-id="element-234">
      <div className="mb-8" data-id="element-235">
        <h1 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-236">
          Welcome to FPX
        </h1>
        <p className="text-gray-600" data-id="element-237">
          Financial Planning Experience - Your personalized financial audit
          tool. View your financial summary below.
        </p>
      </div>
      <div className="mb-10" data-id="element-238">
        <PlayerSummaryCard playerNumber={1} data-id="element-239" />
      </div>
    </div>;
}